module.exports = __webpack_public_path__ + "static/img/banner.5d0a8c6.webp";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/ptgames/banner.webp
// module id = Pq4B
// module chunks = 3